var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{class:`${_vm.carbonPrefix}--side-nav__divider`})
}
var staticRenderFns = []

export { render, staticRenderFns }